const LocalStorage = {
    /**
     * @returns {boolean}
     */
    isEnabled() {
        return !!window.localStorage;
    },

    /**
     * Gets an item from local storage
     * @param {string} key
     * @returns {string|undefined}
     */
    getItem(key) {
        return LocalStorage.isEnabled() ? localStorage.getItem(key) : undefined;
    },

    /**
     * Gets a JSON item from local storage and parses it into an Object
     * @param key
     * @returns {Object}
     */
    getObjectItem(key) {
        const item = LocalStorage.getItem(key);
        if (item) {
            return JSON.parse(item);
        }

        return {};
    },

    /**
     * Removes an item from local storage
     * @param {string} key
     */
    removeItem(key) {
        if (LocalStorage.isEnabled()) {
            localStorage.removeItem(key);
        }
    },

    /**
     * Sets an item in local storage
     *
     * @param {string} key
     * @param {string} data
     */
    setItem(key, data) {
        if (LocalStorage.isEnabled()) {
            localStorage.setItem(key, data);
        }
    },

    /**
     * Sets an object in local storage by first converting it to a string
     *
     * @param {string} key
     * @param {Object} data
     */
    setObjectItem(key, data) {
        LocalStorage.setItem(key, JSON.stringify(data));
    },
};

export default LocalStorage;
